/**
 * Listening and Script have addresses of their own (job #345, Tom 2026-09-26:
 * "we already know which course we are in"). `/listening` and `/script` are
 * the player route with a mode in it, so a mode picked on /me, Talk or the
 * groups goes straight to it, a link opens it, and the back button leaves it.
 * Speaking is the bare `/`.
 *
 * The address and the open mode are kept in step both ways by PlayerContainer:
 * an address with a mode opens it, and a mode opened or left in the player
 * moves the address. This file holds the rules, not the wiring.
 */
export type RouteMode = 'listening' | 'script'

/** The mode an address names, or null for Speaking. */
export function routeModeOf(param: unknown): RouteMode | null {
  const p = Array.isArray(param) ? param[0] : param
  return p === 'listening' || p === 'script' ? p : null
}

export function modePath(mode: RouteMode | null): string {
  return mode ? `/${mode}` : '/'
}

export type RouteStep =
  | { kind: 'none' }
  | { kind: 'push' | 'replace'; path: string }
  | { kind: 'back' }

/**
 * How the address follows the mode the player has open.
 *  - Opening a mode from Speaking is a step forward, so back leaves it.
 *  - Switching one mode for another replaces, so back never walks the modes.
 *  - Leaving a mode steps back when the page behind is Speaking, so the
 *    history does not grow a Speaking entry per visit; otherwise it replaces.
 * `backPath` is vue-router's `history.state.back`.
 */
export function routeStepFor(
  routeMode: RouteMode | null,
  playerMode: RouteMode | null,
  backPath: string | null | undefined,
): RouteStep {
  if (routeMode === playerMode) return { kind: 'none' }
  if (playerMode) return { kind: routeMode ? 'replace' : 'push', path: modePath(playerMode) }
  const back = typeof backPath === 'string' ? backPath.split(/[?#]/)[0] : null
  return back === '/' ? { kind: 'back' } : { kind: 'replace', path: '/' }
}
